import { VoucherUpdatePage } from '@/features/voucher/pages/VoucherUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherUpdatePage,
})
